import * as http from "@/utils/request";
import { RFResponseCommon } from "@/interfaces/common";
import useSWR from "swr";
import rfStore from "@/utils/rfStore";
import { CouponRes, CouponUnReadModel } from "@/interfaces/couponTypes";

const baseUrl = process.env.NEXT_PUBLIC_BASE_API;

/**
 * @summary 获取用户优惠券列表
 */
export function useCouponList() {
	const uid = rfStore.getRFState()?.userId;
	const url = `${baseUrl}/promotion/api/coupon/users/${uid}`;

	const { data, isLoading, mutate, isValidating } = useSWR(
		uid ? url : null,
		async (url) => await http.get<RFResponseCommon<CouponRes[]>>(url).then((res) => res.data),
	);

	return {
		data: data,
		isLoading,
		mutate,
		isValidating,
	};
}

/**
 * @summary 获取卡券未读
 */
export function useCouponUnread() {
	const uid = rfStore.getRFState()?.userId;
	const url = `${baseUrl}/promotion/api/unRead/users/${uid}`;

	const { data, isLoading, mutate } = useSWR(
		uid ? url : null,
		async (url) => await http.get<RFResponseCommon<CouponUnReadModel[]>>(url).then((res) => res.data),
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
			dedupingInterval: 60 * 1000,
		},
	);

	return {
		data,
		isLoading,
		mutate,
	};
}

/*--------------------------*/

/**
 * @summary 删除未读记录
 */

export const deleteUnread = async (unReadType: number) => {
	const uid = rfStore.getRFState()?.userId;
	const url = `${baseUrl}/promotion/api/unRead?unReadType=${unReadType}`;
	try {
		const { code, message } = await http._delete<RFResponseCommon<null>>(url);

		if (code !== 200) throw Error(message);
		return true;
	} catch (error) {
		throw error;
	}
};
